// extracted by mini-css-extract-plugin
export default {"defaultText":"styled-mobile-default-text_defaultText__xent9"};